import Player from './videoPlayer';
export default Player;
